// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill';
import Vue from 'vue'
import $ from 'jquery'

import App from './App'
import router from './router/index'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import './common/components/index.js'
import util from './util/util'
import directives from '@/common/directives/index.js'
Vue.use(directives)


Vue.use(util)

import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo);

//全局引用
import '../static/js/jquery.validationEngine'
import '../static/js/jquery.validationEngine-zh_CN'
import '../static/css/validationEngine.jquery.css'
import '../static/js/jquery.cookie.js'
import '../static/js/jquery-1.7.2.min.js'


import '../static/js/clause'
import '../static/css/frame.css'
import './common/css/tipsMessage.css'

/*------引入全局通用样式------*/
import './common/css/public.css'
import './common/css/common.scss'
/*------引入list样式------*/
/*------引入ico字体样式*/
import '../static/ico/font-awesome.css'
/*------引入ico字体样式*/
/*-------引入elementui的样式修改文件*/
import '../static/css/alterElementuicss.css'
/*-------引入validationEngine的样式文件*/

/*-------引入动画样式文件*/
import '../static/css/animate.min.css'
/*------滚动条样式--------*/
import '../static/js/klorofil-common'
import '../static/js/jquery.slimscroll.min.js'

import { Message } from 'element-ui';
Vue.prototype.$message = Message;

window.eventBus = new Vue();


// 富文本
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
Vue.use(codemirror)

import htmlToPdf from './util/htmlToPdf'
Vue.use(htmlToPdf)

//完整加载
import LuckDraw from 'vue-luck-draw'
Vue.use(LuckDraw)

//无限滚动
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

// 文字说明提示
import Tooltip from "@/components/backstageManagement/public/Tooltip/Tooltip.vue";
Vue.component("Tooltip", Tooltip);
// iconfont组件
import fontIconComm from "@/components/backstageManagement/public/fontIconComm/fontIconComm.vue";
Vue.component("iconComm", fontIconComm);
//多语言设置
//import i18n from '../src/ask/i18n'

// Vue.use(ElementUI,{
//   i18n:(key,value) =>i18n.t(key,value)
// });

Vue.config.productionTip = false

//console.log("🚀 ~ process.env.METHOD", process.env.METHOD)
// let ApiMode
// if(process.env.METHOD==='prod'){
//     ApiMode=By56ApiProd
// }else{
//     ApiMode=By56Api
// }
// 新春样式
Vue.prototype.isNewYear = false;

// 调查问卷
Vue.prototype.IsQuestionnaire = true;

/* eslint-disable no-new i18n, //多语言挂载 */
//isShowIeTips  判断ie  6 7 8 9,时不进入主内容
import store from './store/index.js'

import { post, fetch } from "@/ask/axios";
// 使用fetch API请求JSON文件
fetch('/static/env.json?t=' + new Date().getTime())
  .then(data => {
    // 处理获取的JSON数据
    console.log(data, 'data'); // 打印或以其他方式使用数据
    let ApiMode = getBy56Api(data.env || process.env.METHOD || 'dev');
    //同config.js里面的代码一起注释或放行
    //sysCfg.air = sysCfg.getAir(env || process.env.METHOD || 'dev');
    Object.keys(ApiMode).forEach((v) => {
        Vue.prototype['$' + v] = ApiMode[v]
    })
    if (!isShowIeTips) {
        new Vue({
            el: '#app',
            store,
            router,
            components: { App },
            template: '<App/>'
        })
    }
  })
  .catch(error => {
    // 处理错误情况
    console.error('There has been a problem with your fetch operation:', error);
  });


//    debugger
// //全局接口地址
// Vue.prototype.$api01 = By56Api.api01
// Vue.prototype.$api02 = By56Api.api02
// Vue.prototype.$api03 = By56Api.api03
// Vue.prototype.$api05 = By56Api.api05
// Vue.prototype.$apiAll = By56Api.apiAll
// Vue.prototype.$apiAir = By56Api.apiAir
// Vue.prototype.$nuxtPage = By56Api.nuxtPage
// Vue.prototype.$apiAll03 = By56Api.apiAll03
// Vue.prototype.$apiIMCh = By56Api.apiIMCh


/*
 var req_path ={
 TransitTrade:{
 AirOrder:{
 add:this.$api01+'POST /api/AirOrder/Add', //
 del:'',
 query:'',

 }}
 }*/



// WEBPACK FOOTER //
// ./src/main.js